import { render, staticRenderFns } from "./SuggestionReview.vue?vue&type=template&id=04105ba1&scoped=true&"
import script from "./SuggestionReview.vue?vue&type=script&lang=ts&"
export * from "./SuggestionReview.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionReview.vue?vue&type=style&index=0&id=04105ba1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04105ba1",
  null
  
)

export default component.exports